import "mdn-polyfills/Array.prototype.filter";
import "mdn-polyfills/Node.prototype.remove";

import { app } from "../../appGenerator";
import App from "./App.vue";

export const quizVm = app("articles", App);
